class NewsArticles extends HTMLElement {
  constructor() {
    super();
    const viewAllButtonElem = document.querySelector("[data-view-all-button]");
    viewAllButtonElem.addEventListener("click", () => {
      this.handleViewAllClick();
    });
  }

  handleViewAllClick() {
    const newsArticles = document.querySelectorAll("[data-news-article]");
    Array.from(newsArticles).forEach((newsArticle, index) => {
      newsArticle.classList.remove("hidden");
      setTimeout(() => {
        newsArticle.classList.remove("opacity-0");

        // Only the last article should have a transparent border
        if (index + 1 !== newsArticles.length) {
          newsArticle.classList.remove("md:border-b-transparent");
        }

        // The first article should not have margin-top
        if (index + 1 !== 1) {
          newsArticle.classList.add("mt-8");
        }
      }, 100);
    });
  }
}

customElements.define("news-articles", NewsArticles);
